module.exports = __webpack_public_path__ + "img/FileIcon.55ab08cf.svg";